module.exports = __webpack_public_path__ + "static/media/mule-deer@3x.57424377.jpg";